import * as React from "react";
import TextareaAutosize from "react-textarea-autosize";

import { cn } from "@/lib/utils";

export interface TextareaProps extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, "value"> {
  autoSize?: boolean;
  minRows?: number;
  maxRows?: number;
  value?: React.TextareaHTMLAttributes<HTMLTextAreaElement>["value"] | null;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, autoSize, value, ...props }, ref) => {
    const Component = (autoSize ? TextareaAutosize : "textarea") as any;

    return (
      <Component
        value={value ?? undefined}
        className={cn(
          "flex min-h-[80px] w-full rounded-lg border border-input bg-background px-3 py-2 text-base text-foreground placeholder:text-muted-foreground outline-none transition-colors focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 aria-invalid:ring-3 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          autoSize && "resize-none",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

Textarea.displayName = "Textarea";

export { Textarea };
